import { render } from "./ExerciciosView.vue?vue&type=template&id=3b0a5c41&scoped=true"
import script from "./ExerciciosView.vue?vue&type=script&lang=js"
export * from "./ExerciciosView.vue?vue&type=script&lang=js"

import "./ExerciciosView.vue?vue&type=style&index=0&id=3b0a5c41&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0a5c41"]])

export default __exports__